<template>
    <v-dialog width="500px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="grey lighten-3">
            <v-toolbar color="kbPink" dark flat>
                <span class="text-h6">{{ $t('general.sendSms') }}</span>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-form v-model="valid" ref="formSms" lazy-validation>
                    <v-row>
                        <v-col cols="12">
                            <v-textarea v-model="message"
                                        color="kbDarkBlue"
                                        solo
                                        :label="$t('general.message')"
                                        :rules="[rules.required]">
                            </v-textarea>
                        </v-col>

                        <div v-if="type === 'attendees'">
                            <v-col cols="12" v-if="totalAttendees === 0">
                                {{ $t('general.noAssistantSelected') }}
                            </v-col>

                            <v-col cols="12" v-else>
                                {{ $t('general.thisEmailIsGoingToBeSentTo') }} {{totalAttendees | formatNumber}} {{ $t('general.assistants') }}
                            </v-col>
                        </div>

                        <div v-if="type === 'guests'">
                            <v-col cols="12" v-if="totalInvitedUsers === 0">
                                {{ $t('general.noPersonSelected') }}
                            </v-col>

                            <v-col cols="12" v-else>
                                {{ $t('general.thisEmailIsGoingToBeSentTo') }} {{totalInvitedUsers | formatNumber}} {{ $t('general.people') }}
                            </v-col>
                        </div>

                        <div v-if="type === 'users'">
                            <v-col cols="12" v-if="totalUsers === 0">
                                {{ $t('general.noPersonSelected') }}
                            </v-col>

                            <v-col cols="12" v-else>
                                {{ $t('general.thisEmailIsGoingToBeSentTo') }} {{totalUsers | formatNumber}} {{ $t('general.people') }}
                            </v-col>
                        </div>

                        <div v-if="type === 'events'">
                            <v-col cols="12">
                                {{ $t('general.thisEmailIsGoingToBeSentTo') }}
                                <span> {{ $t('general.allTheEventAssistants', {event: event.title}) }}</span>
                            </v-col>
                        </div>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" outlined @click="toggleModal(false)">{{ $t('general.cancel') }}</v-btn>
                <v-btn color="kbPink" dark @click="submit()" :loading="loading">{{ $t('general.send') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
import rules from '@/libs/rules'
export default {
  computed: {
    ...mapState({
      advancedSearch: state => state.attendees.advancedSearch,
      totalAttendees: state => state.attendees.totalAttendees,
      totalInvitedUsers: state => state.users.totalInvitedUsers,
      totalUsers: state => state.users.totalUsers
    })
  },
  data () {
    return {
      loading: false,
      message: '',
      valid: false,
      rules
    }
  },
  methods: {
    submit () {
      if (!this.$refs.formSms.validate()) return
      this.loading = true
      switch (this.type) {
        case 'events':
          this.sendSms('sendAttendeesSms')
          break
        case 'users':
          this.sendSms('sendUsersSms')
          break
        case 'attendees':
          this.sendSms('sendAttendeesSms')
          break
        case 'guests':
          this.sendSms('sendInvitedUsersSms')
          break
      }
    },
    sendSms (action) {
      if (this.event) this.advancedSearch.eventId = this.event._id
      this.$store.dispatch(action, this.message).then(response => {
        notifications.success(response.message)
        this.$refs.formSms.reset()
        this.loading = false
        this.toggleModal(false)
      }).catch(error => {
        this.loading = false
        notifications.error(error.message)
      })
    },
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: ['event', 'type', 'value']
}
</script>
